// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"e35e1479","585":"731fce6a"}[chunkId] + ".chunk.js";
};